export default "__VITE_ASSET__DD2nm8SZ__"